// src/components/ContactForm.tsx
import React, { useState } from "react";
import { Container, TextField, Button, Typography, MenuItem, Grid, Paper, Alert, Snackbar } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";

const serviceOptions = [
  "Microsoft Enterprise Support",
  "Network & Data Centre Infrastructure",
  "Linux/Web Application Development",
  "Mobile Application (Android)",
  "Cloud Migration & 24/7 Support",
];

export const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    service: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Inquiry Sent:", formData);
    setSubmitted(true);
  };

  return (
    <Container maxWidth="md" sx={{ py: 10 }}>
      <Paper elevation={3} sx={{ p: { xs: 3, md: 6 }, borderRadius: 4 }}>
        <Typography variant="h4" fontWeight={800} gutterBottom>
          Partner With Us
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Have a critical IT issue or an innovative project? Reach out to our expert team for a one-stop solution.
        </Typography>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                fullWidth
                label="Full Name"
                required
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                fullWidth
                label="Email Address"
                type="email"
                required
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                fullWidth
                label="Company Name"
                value={formData.company}
                onChange={(e) => setFormData({ ...formData, company: e.target.value })}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                fullWidth
                select
                label="Interested Service"
                required
                value={formData.service}
                onChange={(e) => setFormData({ ...formData, service: e.target.value })}
              >
                {serviceOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                multiline
                rows={4}
                label="How can we help?"
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <Button
                type="submit"
                variant="contained"
                color="secondary"
                size="large"
                endIcon={<SendIcon />}
                sx={{ px: 6 }}
              >
                Send Inquiry
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>

      <Snackbar open={submitted} autoHideDuration={6000} onClose={() => setSubmitted(false)}>
        <Alert severity="success" sx={{ width: "100%" }}>
          Thank you! The Netcomserve team will contact you shortly.
        </Alert>
      </Snackbar>
    </Container>
  );
};
